import { Fragment, useEffect, useState } from "react";
import {
  // Avatar,
  Box,
  // CardMedia, Container, Divider, Grid, Step, StepLabel, Stepper, Typography
} from "@mui/material";
// import { Circle } from '@mui/icons-material';
// import { BuyerRegistrationIcon, CarIcon, DashedBorderIcon, FontFamily, Images, ReceivedBuyerIdIcon, RequestBuyerIdIcon } from 'assets';
// import { PrimaryButton } from 'components/Buttons';
import { useAuth } from "context/UseContext";
import { useAuthString } from "auth/useAuthStorage";

function AllMarketingTeam() {
  const [, setRenderState] = useState();
  const { user } = useAuth();
  const METABASE_SITE_URL = "https://analytics.galaxyshipping.com";
  const dashboardPermission = process.env.REACT_APP_METABASE_IS_ENABLED;

  const allMarketingTeamReport = useAuthString("allMarketingTeamReport");
  let iframeUrl =
    METABASE_SITE_URL +
    "/embed/dashboard/" +
    allMarketingTeamReport +
    "#bordered=false&titled=true";

  useEffect(() => {
    if (allMarketingTeamReport) {
      setRenderState(allMarketingTeamReport);
    }
  }, [allMarketingTeamReport]);
  return (
    <Fragment>
      {dashboardPermission === "true" ? (
        <>
          {user?.user_type !== "C" && (
            <Box sx={{ height: "100vh" }}>
              <iframe
                title="All Marketing Team analytics dashboard"
                src={iframeUrl}
                frameBorder={0}
                width={"100%"}
                height={"100%"}
                allowTransparency
              />
            </Box>
          )}
        </>
      ) : (
        <></>
      )}
    </Fragment>
  );
}

export default AllMarketingTeam;
